"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("./utils/uuid");
class ManualSignaling {
    constructor() {
        this.textToSend = '';
        this.id = uuid_1.uuid();
    }
    prepare() {
        // Instant ready
        return new Promise(resolve => {
            resolve();
        });
    }
    send(to, data) {
        data.id = to;
        this.textToSend = JSON.stringify(data);
        if (this.onOutgoingDataCallback) {
            this.onOutgoingDataCallback(this.textToSend);
        }
    }
    applyRemoteResponse(data) {
        if (this.onIncomingDataCallback) {
            this.onIncomingDataCallback(data);
        }
    }
    bindOnIncomingDataCallback(callback) {
        this.onIncomingDataCallback = callback;
    }
    bindOnOutgoingDataCallback(callback) {
        this.onOutgoingDataCallback = callback;
    }
    bindInitiateOfferCallback(callback) {
        this.onInitiateOfferCallback = callback;
    }
    bindOnWebRtcConnectionErrorCallback(callback) {
        this.onWebRtcConnectionErrorCallback = callback;
    }
    getId() {
        return this.id;
    }
    initiate() {
        if (this.onInitiateOfferCallback) {
            this.onInitiateOfferCallback(this.id);
        }
    }
    onWebRtcConnectionError(id) {
        if (this.onWebRtcConnectionErrorCallback) {
            this.onWebRtcConnectionErrorCallback(id);
        }
    }
}
exports.ManualSignaling = ManualSignaling;
